export default __webpack_public_path__ + "static/media/secure.59fbf1b0.svg";